module.exports = __webpack_public_path__ + "img/avatar4.cc80f4ab.png";